import React, { useEffect, useState } from 'react';
import CheckTicketBarCodeScanner from './CheckTicketBarCodeScanner';
import CheckTicket from './CheckTicket';
import { AppContext } from '../App';
import CheckTicketQRCodeScanner from './CheckTicketQRCodeScanner';
import { openPopup } from '../data/sport-utils';
import { labels } from '../data/labels';
import { REGEX_URL } from '../data/utils';

export const CheckTicketContext = React.createContext(null);

function CheckTicketPopup(props) {
    const appContext = React.useContext(AppContext);
    const [checkTicketContext, setCheckTicketContext] = useState({
        scannerStarted: false,
        ticketId: null,
        checkbetUrl: null,
        //scannerType: 'BARCODE',
        //scannerType: 'QRCODE',
        update(updt) {
            setCheckTicketContext(prev => {
                return {...prev, ...updt};
            });
        },
        reset(){
            this.update({ticketId:null, checkbetUrl: null, scannerStarted: false});
        },
        setScannerStarted(scannerStarted, scannerType){
            this.update({scannerStarted,scannerType});
        },
        setTicketId(ticketId){
            if(ticketId){
                this.update({ticketId:ticketId, scannerStarted: false});
            }
        },
        setCheckbetUrl(checkbetUrl){
            if(checkbetUrl){
                this.update({checkbetUrl:checkbetUrl, scannerStarted: false});
            }
        }
    });

    useEffect(() => {
        if(checkTicketContext.ticketId){

        }
    }, [checkTicketContext.ticketId]);

    useEffect(() => {
        if(checkTicketContext.checkbetUrl && checkTicketContext.checkbetUrl.match(REGEX_URL)){
            openPopup( checkTicketContext.checkbetUrl,labels['general.checkbet'], 400, 800);
            checkTicketContext.reset();
        }
    }, [checkTicketContext.checkbetUrl]);

    function closePopup(){
        checkTicketContext.reset();
        appContext && appContext.toggleCheckTicketPopup();
    }

    return (
        <CheckTicketContext.Provider value={checkTicketContext}>
            <div id="checkTicketPopupContainer" >
                <div className="customPopup">
                    <div className="customPopup__content">
                        <div className="customPopup__content__header">
                            <div className="customPopup__content__header__title">
                                <p className="bianco">{labels['check_ticket.check_ticket']}</p>
                            </div>
                            <button className="customPopup__content__header__closeButton" onClick={closePopup} >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <div className="customPopup__content__body">
                        {checkTicketContext.scannerStarted?
                            (checkTicketContext.scannerType=='BARCODE'?
                            <CheckTicketBarCodeScanner/>
                            :
                            <CheckTicketQRCodeScanner/>
                            )
                           
                        :
                        <CheckTicket openTicketScanner={props.openTicketScanner} />
                        }
                        </div>
                    </div>
                    </div> 
            </div>
        </CheckTicketContext.Provider>
    )
}

export default CheckTicketPopup;